export const StarIcon = (props: any) => (
  <svg
    {...props}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.24 2.76305C9.75 2.27305 9.085 1.99805 8.39 1.99805C7.7 1.99805 7.035 2.27305 6.545 2.76305L6 3.30305L5.46 2.75805C4.97 2.27305 4.305 1.99805 3.61 1.99805C2.92 1.99805 2.255 2.27305 1.765 2.75805C1.275 3.25305 1 3.91805 1 4.60805C1 5.30305 1.275 5.96805 1.765 6.45805L5.65 10.348C5.695 10.398 5.75 10.433 5.81 10.458C5.87 10.483 5.935 10.498 6 10.498C6.065 10.498 6.13 10.483 6.195 10.458C6.255 10.433 6.31 10.398 6.355 10.353L10.24 6.46305C10.73 5.96805 11.005 5.30305 11.005 4.61305C11.005 3.91805 10.73 3.25305 10.24 2.76305Z"
      fill="currentColor"
    />
  </svg>
)
